import React, { useState } from "react";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomInput from "../../Shared/CustomInput";
import CustomSelect from "../../Shared/CustomSelect";
import {
  bloodOption,
  classOptions,
  genderOptions,
  sectionOption,
  subjectOptions,
} from "../../utils/helpers";
import SubmitForm from "../../Shared/SubmitForm";
const Admission = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  function onSubmit(data) {
    console.log("submitting the form", data);
  }
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Students</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Student Admit Form</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>Add New Students</h3>
            </div>
            <Cta />
          </div>
          <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"First Name *"}
                  register={register}
                  errors={errors}
                  name={"firstname"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Last Name *"}
                  register={register}
                  errors={errors}
                  name={"lastname"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Gender *"}
                  register={register}
                  errors={errors}
                  name={"gender"}
                  placeholder={"Please Select Gender*"}
                  option={genderOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Date Of Birth *</label>
                <input
                  type="text"
                  placeholder="dd/mm/yyyy"
                  class="form-control air-datepicker"
                  data-position="bottom right"
                  {...register("dob", { required: "DOB is required" })}
                />
                <i class="far fa-calendar-alt"></i>
                {errors.dob && (
                  <p style={{ color: "red" }}>{errors.dob.message}</p>
                )}
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Roll Number *"}
                  register={register}
                  errors={errors}
                  name={"roll"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Blood Group *"}
                  register={register}
                  errors={errors}
                  name={"bloodgroup"}
                  placeholder={"Please Select Group*"}
                  option={bloodOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Religion *"}
                  register={register}
                  errors={errors}
                  name={"religion"}
                  placeholder={"Please Select Religion *"}
                  option={bloodOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Email *"}
                  register={register}
                  errors={errors}
                  name={"email"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Class *"}
                  register={register}
                  errors={errors}
                  name={"class"}
                  placeholder={"Please Select Class *"}
                  option={classOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Class *"}
                  register={register}
                  errors={errors}
                  name={"class"}
                  placeholder={"Please Select Class *"}
                  option={sectionOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Admission ID *"}
                  register={register}
                  errors={errors}
                  name={"admissionId"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Phone *"}
                  register={register}
                  errors={errors}
                  name={"phone"}
                />
              </div>
              <div class="col-lg-6 col-12 form-group">
                <label>Short BIO</label>
                <textarea
                  class="textarea form-control"
                  name="message"
                  {...register("bio", {
                    required: "max length 1400 character",
                    maxLength: { value: 3, message: "max length 1400" },
                  })}
                  id="form-message"
                  cols="10"
                  rows="9"
                ></textarea>
                {errors.bio && (
                  <p style={{ color: "red" }}>{errors.bio.message}</p>
                )}
              </div>
              <div class="col-lg-6 col-12 form-group mg-t-30">
                <label class="text-dark-medium">
                  Upload Student Photo (150px X 150px)
                </label>
                <input type="file" class="form-control-file" />
              </div>
              <SubmitForm />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Admission;
